import { Action } from "@ngrx/store";
import { ICustomer, IDigitalChecklist, IDigitalChecklistAppointment, IDigitalChecklistRequest } from "@signal/asp-data-commons";
import { IDigitalChecklistForm } from "./delivery-checklist.reducer";

export const DeliveryChecklistActionTypes = {
  LOAD_CHECKLIST_SUMMARY: '[Delivery Checklist Summary page] Load Checklist Summary',
  LOAD_CHECKLIST_SUMMARY_SUCCESS: '[Delivery Checklist Summary page] Load Checklist Summary Success',
  LOAD_CHECKLIST_SUMMARY_FAILURE: '[Delivery Checklist Summary page] Load Checklist Summary Failure',
  CLEAN_CHECKLIST_SUMMARY_STATE: '[Delivery Checklist Summary page] Clean Checklist Summary State',
  UPDATE_FORM_DATA: '[Delivery Checklist page] form data updated in state',
  LOAD_CUSTOMER_DETAILS: '[Delivery Checklist page] load signed in customer details in initial state',
  LOAD_CHECKLIST: '[Delivery Checklist page] Load checklist',
  LOAD_CHECKLIST_SUCCESS: '[Delivery Checklist page] Load checklist success',
  LOAD_CHECKLIST_FAILURE: '[Delivery Checklist page] Load checklist failure',
  LOAD_ARCHIVED_CHECKLISTS: '[Delivery Checklist page] Load archived checklists',
  LOAD_ARCHIVED_CHECKLISTS_SUCCESS: '[Delivery Checklist page] Load archived checklists success',
  CLEAN_ARCHIVED_SUMMARY_STATE: '[Delivery Checklist Summary page] Clean Archived Checklist State',
  LOAD_ARCHIVED_CHECKLISTS_FAILURE: '[Delivery Checklist page] Load archived checklists failure',
  CREATE_CHECKLIST: '[Delivery Checklist page] Populate checklist',
  UPDATE_SIGNATURE_FORM_DATA: '[Delivery Checklist Page] Update signature data',
  RESET_DIGICHECK_STATE: '[Delivery Checklist Page] Reset digital checklist state',
  CREATE_DIGICHECK_REQUEST: '[Delivery Checklist Page] Create New Digital Checklist Request',
  CREATE_DIGICHECK_REQUEST_SUCCESS: '[Delivery Checklist Page] Create New Digital Checklist Request Success',
  CREATE_DIGICHECK_REQUEST_FAILURE: '[Delivery Checklist Page] Create New Digital Checklist Request Failure',
  GET_EDIT_DATA: '[Delivery Checklist Page] fetching edit details from DB',
  GET_EDIT_DATA_SUCCESS: '[Delivery Checklist Page] fetching edit details from DB success',
  GET_EDIT_DATA_FAILURE: '[Delivery Checklist Page] fetching edit details from DB failure',
  UPDATE_DESCRIPTION: '[Delivery Checklist Page] update description data',
  EDIT_DIGICHECK_REQUEST: '[Delivery Checklist Page] edit Digital Checklist Request',
  EDIT_DIGICHECK_REQUEST_SUCCESS: '[Delivery Checklist Page] edit Digital Checklist Request success',
  EDIT_DIGICHECK_REQUEST_FAILURE: '[Delivery Checklist Page] edit Digital Checklist Request failure',
  CANCEL_DIGICHECK: '[Delivery Checklist Page] Delete Digital Checklist',
  CANCEL_DIGICHECK_SUCCESS: '[Delivery Checklist Page] Delete Digital Checklist Success',
  CANCEL_DIGICHECK_FAILURE: '[Delivery Checklist Page] Delete Digital Checklist Failure',
  SEND_EMAIL: '[Delivery Checklist Page] Send Email',
  SEND_EMAIL_SUCCESS: '[Delivery Checklist Page] Send Email Success',
  SEND_EMAIL_FAILURE: '[Delivery Checklist Page] Send Email Failure',
  RESUBMIT_DIGICHECK_REQUEST: '[Delivery Checklist Page] Resubmit Digital Checklist Request',
  RESUBMIT_DIGICHECK_REQUEST_SUCCESS: '[Delivery Checklist Page] Resubmit Digital Checklist Request Success',
  RESUBMIT_DIGICHECK_REQUEST_FAILURE: '[Delivery Checklist Page] Resubmit Digital Checklist Request Failure'
}
export class LoadChecklistSummary implements Action {
  readonly type: string = DeliveryChecklistActionTypes.LOAD_CHECKLIST_SUMMARY;
  constructor(public payload: { checklistSummaryStatus: string, pageNumber:number,pageSize:number,appendData:boolean,filters?:any }) {
  }
}

export class LoadChecklistSummarySuccess implements Action {
  readonly type: string = DeliveryChecklistActionTypes.LOAD_CHECKLIST_SUMMARY_SUCCESS;

  constructor(public payload: { checklist: IDigitalChecklistAppointment[],totalCount:number,appendData:boolean}) {
  }
}

export class LoadChecklistSummaryFailure implements Action {
  readonly type: string = DeliveryChecklistActionTypes.LOAD_CHECKLIST_SUMMARY_FAILURE;

  constructor(public payload: { error: string }) {
  }
}

export class CleanChecklistSummaryState implements Action {
  readonly type: string = DeliveryChecklistActionTypes.CLEAN_CHECKLIST_SUMMARY_STATE;

  constructor(public payload: {}) {
  }
}

export class UpdateFormData implements Action {
  readonly type: string = DeliveryChecklistActionTypes.UPDATE_FORM_DATA;

  constructor(public payload: { value: IDigitalChecklistForm }) {
  }
}

export class LoadCustomerDetails implements Action {
  readonly type: string = DeliveryChecklistActionTypes.LOAD_CUSTOMER_DETAILS;

  constructor(public payload: { signedInUserDetails: ICustomer }) {
  }
}

export class LoadChecklist implements Action {
  readonly type: string = DeliveryChecklistActionTypes.LOAD_CHECKLIST;

  constructor(public payload: { fuelType: string }) { }
}

export class LoadChecklistSuccess implements Action {
  readonly type = DeliveryChecklistActionTypes.LOAD_CHECKLIST_SUCCESS;

  constructor(public payload: { checklistDetails: IDigitalChecklist[] }) {
  }
}

export class LoadChecklistFailure implements Action {
  readonly type = DeliveryChecklistActionTypes.LOAD_CHECKLIST_FAILURE;

  constructor(public payload: { error: string }) {
  }
}
export class LoadArchivedChecklists implements Action {
  readonly type: string = DeliveryChecklistActionTypes.LOAD_ARCHIVED_CHECKLISTS;

  constructor(public payload: { year:number,month:number,pageNumber:number,pageSize:number,filters?:any }) { }
}

export class LoadArchivedChecklistsSuccess implements Action {
  readonly type = DeliveryChecklistActionTypes.LOAD_ARCHIVED_CHECKLISTS_SUCCESS;

  constructor(public payload: { checklistDetails: IDigitalChecklistAppointment[],totalCount:number,year:number,month:number }) {
  }
}

export class LoadArchivedChecklistsFailure implements Action {
  readonly type = DeliveryChecklistActionTypes.LOAD_ARCHIVED_CHECKLISTS_FAILURE;

  constructor(public payload: { error: string }) {
  }
}

export class CleanArchivedChecklistsState implements Action {
  readonly type = DeliveryChecklistActionTypes.CLEAN_ARCHIVED_SUMMARY_STATE;

  constructor(public payload: { }) {
  }
}


export class CreateChecklist implements Action {
  readonly type: string = DeliveryChecklistActionTypes.CREATE_CHECKLIST;

  constructor(public payload: { data: IDigitalChecklistRequest[] }) {
  }
}

export class UpdateSignatureFormData implements Action {
  readonly type: string = DeliveryChecklistActionTypes.UPDATE_SIGNATURE_FORM_DATA;

  constructor(public payload: { value: any }) {
  }
}

export class ResetDigiCheckState implements Action {
  readonly type: string = DeliveryChecklistActionTypes.RESET_DIGICHECK_STATE;
  constructor() {

  }
}

export class CreateDigiChekReq implements Action {
  readonly type: string = DeliveryChecklistActionTypes.CREATE_DIGICHECK_REQUEST;

  constructor(public payload: { isSaveForLater: boolean, isVinValid?: boolean }) {
  }
}

export class CreateDigiChekReqSuccess implements Action {
  readonly type: string = DeliveryChecklistActionTypes.CREATE_DIGICHECK_REQUEST_SUCCESS;

  constructor(public payload: { reqModel: IDigitalChecklistAppointment }) {
  }
}

export class CreateDigiChekReqFail implements Action {
  readonly type: string = DeliveryChecklistActionTypes.CREATE_DIGICHECK_REQUEST_FAILURE;

  constructor(public payload: { error: string }) {
  }
}

export class ResubmitDigiChekReq implements Action {
  readonly type: string = DeliveryChecklistActionTypes.RESUBMIT_DIGICHECK_REQUEST;

  constructor(public payload: { digitalChecklist }) {
  }
}

export class ResubmitDigiChekReqSuccess implements Action {
  readonly type: string = DeliveryChecklistActionTypes.RESUBMIT_DIGICHECK_REQUEST_SUCCESS;

  constructor(public payload: { digitalChecklist }) {
  }
}

export class ResubmitDigiChekReqFailure implements Action {
  readonly type: string = DeliveryChecklistActionTypes.RESUBMIT_DIGICHECK_REQUEST_FAILURE;

  constructor(public payload: { error: string }) {
  }
}

export class UpdateDescription implements Action {
  readonly type: string = DeliveryChecklistActionTypes.UPDATE_DESCRIPTION;

  constructor(public payload: { description: string }) {
  }
}
export class GetEditData implements Action {
  readonly type: string = DeliveryChecklistActionTypes.GET_EDIT_DATA;

  constructor(public payload: { digiChekId: string }) {
  }
}

export class GetEditDataSuccess implements Action {
  readonly type: string = DeliveryChecklistActionTypes.GET_EDIT_DATA_SUCCESS;

  constructor(public payload: { checklistModel: IDigitalChecklistAppointment }) {
  }
}

export class GetEditDataFail implements Action {
  readonly type: string = DeliveryChecklistActionTypes.GET_EDIT_DATA_FAILURE;

  constructor(public payload: { error: string }) {
  }
}

export class EditDigiCheckReq implements Action {
  readonly type: string = DeliveryChecklistActionTypes.EDIT_DIGICHECK_REQUEST;

  constructor(public payload: { isSaveForLater?: boolean, isVinValid?: boolean }) {
  }
}

export class EditDigiCheckReqSuccess implements Action {
  readonly type: string = DeliveryChecklistActionTypes.EDIT_DIGICHECK_REQUEST_SUCCESS;

  constructor(public payload: { checklistModel: IDigitalChecklistAppointment }) {
  }
}

export class EditDigiCheckReqFail implements Action {
  readonly type: string = DeliveryChecklistActionTypes.EDIT_DIGICHECK_REQUEST_FAILURE;

  constructor(public payload: { error: string }) {
  }
}

export class CancelChecklist implements Action {
  readonly type: string = DeliveryChecklistActionTypes.CANCEL_DIGICHECK;

  constructor(public payload: { digitalChecklist: IDigitalChecklistAppointment }) {
  }
}

export class CancelChecklistSuccess implements Action {
  readonly type: string = DeliveryChecklistActionTypes.CANCEL_DIGICHECK_SUCCESS;

  constructor(public payload: { digitalChecklistId: string }) {
  }
}

export class CancelChecklistFailure implements Action {
  readonly type: string = DeliveryChecklistActionTypes.CANCEL_DIGICHECK_FAILURE;

  constructor(public payload: { error: string }) {
  }
}

export class SendEmail implements Action {
  readonly type: string = DeliveryChecklistActionTypes.SEND_EMAIL;

  constructor(public payload: { digitalChecklist: IDigitalChecklistAppointment, type: string, emailAddress?: string }) {
  }
}
export class SendEmailSuccess implements Action {
  readonly type: string = DeliveryChecklistActionTypes.SEND_EMAIL_SUCCESS;

  constructor(public payload: { digitalChecklistId: string }) {
  }
}

export class SendEmailFailure implements Action {
  readonly type: string = DeliveryChecklistActionTypes.SEND_EMAIL_FAILURE;

  constructor(public payload: { error: string }) {
  }
}

export type DeliveryChecklistActions =
  | LoadChecklistSummary
  | LoadChecklistSummarySuccess
  | LoadChecklistSummaryFailure
  | CleanChecklistSummaryState
  | UpdateFormData
  | LoadCustomerDetails
  | LoadChecklist
  | LoadChecklistSuccess
  | LoadChecklistFailure
  | CreateChecklist
  | LoadArchivedChecklists
  | LoadArchivedChecklistsSuccess
  | LoadArchivedChecklistsFailure
  | CleanArchivedChecklistsState
  | UpdateSignatureFormData
  | ResetDigiCheckState
  | CreateDigiChekReq
  | CreateDigiChekReqSuccess
  | CreateDigiChekReqFail
  | EditDigiCheckReq
  | EditDigiCheckReqSuccess
  | EditDigiCheckReqFail
  | GetEditData
  | GetEditDataSuccess
  | GetEditDataFail
  | CancelChecklist
  | CancelChecklistSuccess
  | CancelChecklistFailure
  | SendEmail
  | SendEmailSuccess
  | SendEmailFailure
  | UpdateDescription